import { Role } from '../enums/role.enum';
import { UserPermission } from '../enums/user-permission.enum';
import { UserGrant } from '../interfaces/user-grant.interface';
import { User } from '../interfaces/user.interface';

export function maasBillingGrantOf(user: User): UserGrant | undefined {
	return user.grants?.find((grant) => grant.permission === UserPermission.MAAS_BILLING);
}

export function hasMaasBilling(user: User): boolean {
	return user.role === Role.superuser || !!maasBillingGrantOf(user);
}
